import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { useImmer } from 'use-immer';
import * as Yup from 'yup';
import { Button, Modal, Form, Col, Alert } from 'react-bootstrap';
import FormControls from '../formControls';

const employeeUserInitValues = {
    id: 0,
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: {
        number: '',
        phoneType: null
    },
    userType: 1,
    roleId: 0,
    accountId: 1,
    state: 100
}

const employeeUserValidation = Yup.object().shape({
    firstName: Yup.string().min(2, 'First name must be greater than two characters.').required('First name is required.'),
    lastName: Yup.string().min(2, 'Last name must be greater than two charcters.').required('Last name is required.'),
    emailAddress: Yup.string().email('Email address is not in the correct format').required('Email address is required.'),
    roleId: Yup.number().min(1, "Role is required.")
});

const CreateEmployeeUserModal = (props) => {
    const [saveError, setSaveError] = useImmer('');
    const [employeeUser, setEmployeeUser] = useImmer(employeeUserInitValues);

    useEffect(() => {
        setEmployeeUser(draft => Object.assign(draft, props.model));
    }, [props.model])

    const formik = useFormik({
        initialValues: employeeUserInitValues,
        validationSchema: employeeUserValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            setSaveError('');
            var returnVal = await props.saveModel(values)
            if (!returnVal.result) {
                setSaveError(returnVal.message);
            } else {
                props.closeModal();
            }
            setSubmitting(false);
        }
    });

    return (
        <>
            <Modal.Header>Create new user</Modal.Header>
            <Modal.Body>
                <Form.Row>
                    <Alert variant='danger' show={saveError}>{saveError}</Alert>
                    <Form.Group as={Col} lg="6" md="12">
                        <FormControls.Textbox
                            name="firstName"
                            label="First Name"
                            formHandler={formik} />
                    </Form.Group>
                    <Form.Group as={Col} lg="6" md="12">
                        <FormControls.Textbox
                            name="lastName"
                            label="Last Name"
                            formHandler={formik} />
                    </Form.Group>
                </Form.Row>
                <FormControls.ConditionalRender visible={formik.values.id > 0}>
                    <Form.Row>
                        <FormControls.ButtonGrouping
                            label="State"
                            name="state"
                            size="sm"
                            variant="secondary"
                            formHandler={formik}
                            options={[
                                { value: 100, name: "Active" },
                                { value: -50, name: "Suspended" },
                                { value: -100, name: "Deleted" }]} />
                    </Form.Row>:
                </FormControls.ConditionalRender>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.Textbox
                            name="emailAddress"
                            label="Email Address"
                            type="email"
                            formHandler={formik} />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.SelectBox
                            label="Role"
                            name="roleId"
                            numeric
                            formHandler={formik}
                            defaultValue={0}
                            showDefault
                            defaultLabel="Select role ..."
                            onChange={(e) => {
                                const val = parseInt(e.target.value);
                                formik.setFieldValue("roleId", val, true)
                            }}
                            options={props.roles}
                        />
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="default" onClick={() => props.closeModal()}>Cancel</Button>
                <Button variant="primary" onClick={() => formik.submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    )
}
export default CreateEmployeeUserModal;


//class CreateEmployeeUserModel2 extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = {
//            user: {
//                firstName: '', lastName: '', emailAddress: '', phoneNumber: { number: '', phoneType: null }, userType: 1, accountId: 0
//            },
//            errors: { firstName: '', lastName: '', emailAddress: '', roleId: '', number: '', phoneType: '', general: '' }
//        };

//        this.handleUserInput = this.handleUserInput.bind(this);
//        this.handleUserIntInput = this.handleUserIntInput.bind(this);
//        //this.handlePhoneInput = this.handlePhoneInput.bind(this);
//        //this.handlePhoneIntInput = this.handlePhoneIntInput.bind(this);
//        this.saveModel = this.saveModel.bind(this);
//        this.validateField = this.validateField.bind(this);
//    }

//    componentDidMount() {
//        var user = this.state.user;
//        user.accountId = 1; // I pass the account id in the model
//        this.setState({ user: user });
//    }

//    validateField(event) {
//        const validEmailRegex =
//            RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

//        var validPhone = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);



//        const { name, value } = event.target;
//        let errors = this.state.errors;

//        switch (name) {
//            case 'firstName':
//                errors.firstName =
//                    this.state.user.firstName.length < 1
//                        ? 'First Name is not valid!'
//                        : '';
//                break;
//            case 'lastName':
//                errors.lastName =
//                    this.state.user.firstName.length < 1
//                        ? 'Last Name is not valid!'
//                        : '';
//                break;
//            case 'emailAddress':
//                errors.emailAddress =
//                    validEmailRegex.test(this.state.user.emailAddress)
//                        ? ''
//                        : 'Email is not valid!';
//                break;
//            case 'roleId':
//                errors.roleId = this.state.user.roleId > 0
//                    ? ''
//                    : 'You must select a role!';
//            default:
//                break;
//        }

//        this.setState({ errors });
//    }

//    async saveModel() {
//        var result = await this.props.saveModel(this.state.user);
//        if (result != undefined && !result.result) {
//            var partialState = this.state.errors;
//            partialState.general = result.message;
//            this.setState({ errors: partialState });
//        }
//    }
//    handleUserInput(event) {
//        // taken straight from the React Docs
//        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
//        const target = event.target;
//        const value = target.type === 'checkbox' ? target.checked : target.value;
//        const name = target.name;
//        var partialState = this.state.user;
//        partialState[name] = value;
//        this.setState({ user: partialState });
//    }

//    handleUserIntInput(event) {
//        // taken straight from the React Docs
//        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
//        const target = event.target;
//        const value = parseInt(target.value);
//        const name = target.name;
//        var partialState = this.state.user;
//        partialState[name] = value;
//        this.setState({ user: partialState });
//    }

//    render() {
//        return (
//            <>
//                <Modal.Header>Create new contact</Modal.Header>
//                <Modal.Body>
//                    <Form.Row>
//                        <Form.Group as={Col} lg="6" md="12">
//                            <Form.Label>First Name</Form.Label>
//                            <Form.Control placeholder="Enter first name" name="firstName" id="firstName"
//                                value={this.state.user.firstName}
//                                onChange={this.handleUserInput}
//                                onBlur={this.validateField}
//                            />
//                            <small id="phoneNumberWarning" className="form-text text-danger" style={this.state.errors.firstName != '' ? null : { "display": "none" }}><b>{this.state.errors.firstName}</b></small>
//                        </Form.Group>
//                        <Form.Group as={Col} lg="6" md="12">
//                            <Form.Label>Last Name</Form.Label>
//                            <Form.Control placeholder="Enter last name" name="lastName" id="lastName"
//                                value={this.state.user.lastName}
//                                onChange={this.handleUserInput}
//                                onBlur={this.validateField}
//                            />
//                            <small id="phoneNumberWarning" className="form-text text-danger" style={this.state.errors.lastName != '' ? null : { "display": "none" }}><b>{this.state.errors.lastName}</b></small>
//                        </Form.Group>
//                    </Form.Row>
//                    <Form.Row>
//                        <Form.Group as={Col} lg="12" md="12">
//                            <Form.Label>Email Address</Form.Label>
//                            <Form.Control type="email" placeholder="Enter email address" name="emailAddress" id="emailAddress"
//                                value={this.state.user.emailAddress}
//                                onChange={this.handleUserInput}
//                                onBlur={this.validateField} />
//                            <small id="emailAddressWarning" className="form-text text-danger" style={this.state.errors.emailAddress != '' ? null : { "display": "none" }}><b>{this.state.errors.emailAddress}</b></small>
//                        </Form.Group>
//                    </Form.Row>
//                    <Form.Row>
//                        <Form.Control as="select"
//                            value={this.state.user.roleId}
//                            onBlur={this.validateField}
//                            name="roleId"
//                            feedback={this.state.errors.roleId}
//                            isInvalid={this.state.errors.roleId != ''}
//                            style={{ maxWidth: "300px" }}
//                            id={"roleId"}
//                            onChange={this.handleUserIntInput}>
//                            <option key={null} value={0}>Select role...</option>
//                            {this.props.model.map((role, idx) => 
//                                <option key={idx} value={role.id}>{role.name}</option>)}
//                        </Form.Control>
//                    </Form.Row>
//                    <Alert variant="danger" style={this.state.errors.general != '' ? null : { "display": "none" }}>
//                        {this.state.errors.general}
//                    </Alert>
//                </Modal.Body>
//                <Modal.Footer>
//                    <Button bsStyle="default" onClick={this.props.hideModal}>Cancel</Button>
//                    <Button bsStyle="primary" onClick={() => this.saveModel()}>Save</Button>
//                </Modal.Footer>
//            </>
//        );
//    }
//}

//export default CreateEmployeeUserModel2